<div #stickyFooterContainer>
  <div class="min-[643px]:hidden" #divAddFooterHeight></div>

  <div
    #stickyFooter
    class="bg-neutralBg p-4 flex flex-col rounded-xl max-[642px]:fixed max-[642px]:left-0 min-[643px]:max-w-[610px] max-[642px]:bottom-0"
  >
    <ng-content></ng-content>
  </div>
</div>
